import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#224277',
    lighten1: '#EBEBEB',
    lighten2: '#F07FDE',
    lighten3: '#F0EB7F',
    lighten4: '#C3F07F',
    lighten5: '#7FB387',
    lighten6: '#7FD9FF',
    darken1: '#FF877F',
    darken2: '#FFCB7F',
    darken3: '#1B6396',
    darken4: '#30a0bd',
    darken5: '#3B3C3A'    
  },
  secondary: {
    base: '#03DAC5',
    lighten1: '#F7ECE9',
    lighten2: '#DBB2FF',
    lighten3: '#00C4B4',
    lighten4: '#00B3A6',
    darken1: '#D1645A',
    darken2: '#35A2BE',
    darken3: '#FFDD41',
    darken4: '#FFD71E',
    darken5: '#F3C800'
  },
  onPrimary: {
    base: '#008088',
    darken1: '#FFFBA4',
    lighten1: '#FFFFDA',
    lighten2: '#D4F2F4',
    lighten3: '#98E2E6',
    lighten4: '#FCFCFC'
  }, 
  onSecondary: {    
    lighten1: '#F7F7F7',    
    lighten2: '#9F9F9F',    
    lighten3: '#727272',    
    lighten4: '#F9F9EA',        
    lighten5: '#EDEDEC',    
  },   
  accent: {
    base: '#008088',
  },
  //accent: colors.blue.accent1,
  error: {
    //colors.red.accent2,
    base: '#D1645A'
  },
  info: {
    base: '#3b3c3a'
  },
  success: {
    base: '#308500'
  },
  warning: {
    base: '#ee7200'
  },
  anchor: colors.blue.darken2
}